import React, { memo } from 'react';
import CloseIcon from '../svg/CloseIcon';
import DropdownIcon from '../svg/DropdownIcon';
import CheckboxArrow from '../svg/CheckboxArrow';

const Filterbar = ({
	memoizedFilteredCount,

	memoizedActiveFilterDate,
	memoizedActiveTimestamp,
	memoizedActiveLocations,
	memoizedActiveProductions,
	memoizedActiveCategories,
	memoizedIsNDR,
	isNDR,

	availableDatesMonths,
	availableLocations,
	availableProductions,
	availableCategories,

	memoizedAvailableLocationsFiltered,
	memorizedAvailableProductionsFiltered,
	memoizedAvailableCategoriesFiltered,

	setDateParam,
	setLocationsParam,
	setProductionsParam,
	setCategoriesParam,
	setIsNDRParam,
	resetParams,

	showModal,
	setShowModal,
	rootElement,
}) => {
	const toggleModal = () => {
		setShowModal(!showModal);
	};

	const displayAmountActiveFilters = () => {
		let counter = 0;
		counter += memoizedActiveLocations.length + memoizedActiveCategories.length + (memoizedIsNDR ? 1 : 0) + (memoizedActiveFilterDate ? 1 : 0);
		//productions are excluded from count because on mobile it is not part of the filter modal
		if (counter <= 0) return '';
		return counter;
	};

	const handleParamClick = (value, group, disabled, active) => {
		if (!disabled || active) {
			if (group === 'location') {
				setLocationsParam(value);
				return;
			}
			if (group === 'category') {
				setCategoriesParam(value);
				return;
			}
			if (group === 'production') {
				setProductionsParam(value);
				return;
			}
			if (group === 'month') {
				setDateParam(value);
			}
		}
	};

	//returns a param object with value, active and disabled keys
	const getParamLabels = (group) => {
		if (group === 'location') {
			return availableLocations.map((location) => {
				return {
					value: location,
					name: Object.values(location)[0],
					active: memoizedActiveLocations.includes(location),
					disabled: memoizedAvailableLocationsFiltered && !memoizedAvailableLocationsFiltered.includes(location),
				};
			});
		}
		if (group === 'month') {
			const months = availableDatesMonths.map((month) => {
				return {
					value: month,
					name: new Date(month).toLocaleString('nl-NL', { month: 'long' }),
					active: memoizedActiveTimestamp === month,
					disabled: false,
				};
			});
			months.unshift({
				value: 'all',
				name: 'Alle maanden',
				active: !memoizedActiveFilterDate,
				disabled: false,
			});
			return months;
		}
		if (group === 'category') {
			return availableCategories.map((category) => {
				return {
					value: category,
					name: Object.values(category)[0],
					active: memoizedActiveCategories.includes(category),
					disabled: memoizedAvailableCategoriesFiltered && !memoizedAvailableCategoriesFiltered.includes(category),
				};
			});
		}
		if (group === 'production') {
			return availableProductions.map((production) => {
				return {
					value: production,
					name: Object.values(production)[0], //todo: change production to object as well
					active: memoizedActiveProductions.includes(production),
					disabled: memorizedAvailableProductionsFiltered && !memorizedAvailableProductionsFiltered.includes(production),
				};
			});
		}
	};

	const handleNDRClick = () => {
		setIsNDRParam(!isNDR);
	};

	const handleKeyDown = (event) => {
		// Check if the key is Enter or Space
		if (event.key === 'Enter' || event.key === ' ') {
			 handleNDRClick();
		}
  };

	const handleTagClass = (param) => {
		let className = 'tag';
		if (param.active) {
			className += ' tag--active';
		} else if (param.disabled) {
			className += ' tag--disabled';
		}
		return className;
	};

	const closeFilterDropdowns = (e) => {
		if (!e.target.classList.contains('.custom-select') && e.target.closest('.custom-select') == null) {
			rootElement.removeEventListener('mousedown', closeFilterDropdowns);
			rootElement.querySelectorAll('.js_react_filter .custom-select__trigger').forEach((element) => {
				element.setAttribute('aria-expanded', 'false');
			});
		}
	};

	const toggleSelectList = (e) => {
		if (e.target.tagName.toLowerCase() === 'li' || e.target.tagName.toLowerCase() === 'ul' || e.target.tagName.toLowerCase() === 'input' || e.target.tagName.toLowerCase() === 'label') {
			return;
		}

		rootElement.removeEventListener('mousedown', closeFilterDropdowns); //commented to keep the dropdown open while selecting
		rootElement.addEventListener('mousedown', closeFilterDropdowns);
		rootElement.querySelectorAll('.js_react_filter .custom-select__trigger').forEach((element) => {
			if (e.currentTarget.contains(element)) {
				element.setAttribute('aria-expanded', element.getAttribute('aria-expanded') == 'true' ? 'false' : 'true');
			} else {
				element.setAttribute('aria-expanded', 'false');
			}
		});
	};

	const isActiveGroup = (group) => {
		if (group === 'location' && memoizedActiveLocations.length > 0) return true;
		if (group === 'month' && memoizedActiveFilterDate) return true;
		if (group === 'category' && memoizedActiveCategories.length > 0) return true;
		if (group === 'production' && memoizedActiveProductions.length > 0) return true;
		return false;
	};

	const getGroupLabel = (group) => {
		if (isActiveGroup(group)) {
			if (group === 'location') return customData.i18n.agenda_location_name;
			if (group === 'month') return new Date(memoizedActiveTimestamp).toLocaleString('nl-NL', { month: 'long' });
			if (group === 'category') return customData.i18n.agenda_category_name;
			if (group === 'production') return customData.i18n.agenda_production_name;
		}
		return customData.i18n[`agenda_${group}_name`];
	};

	return (
		<>
			<div id="mainContent" className="filter filter-desktop show-for-tablet-l-up">

				{/* create 4 different filter options in dropdowns based on group names */}
				{['production', 'month', 'category', 'location'].map((group, index) => {
					return (
						<div key={index} className={`dropdown input custom-select ${isActiveGroup(group) ? 'has-selected' : ''}`} onClick={(e) => toggleSelectList(e)}>
							{/* selection button for dropdown */}
							<button className="custom-select__trigger" aria-haspopup="listbox" aria-labelledby="bioscoop_label" aria-expanded="false">
								<div className="chosen-label">
									{/* Dynamic title inside button for dropdown */}
									<p className="filter-label">{getGroupLabel(group)}</p>
									<DropdownIcon />
								</div>
							</button>

							<ul className="listbox listbox--multi listbox--multi-cinema" role="listbox" aria-labelledby="bioscoop_label" aria-multiselectable="true" aria-activedescendant="">
								{/* get all options for this group */}
								{getParamLabels(group).map((param, paramIndex) => {
									return (
										<li
											key={paramIndex}
											role="option"
											onClick={() => handleParamClick(param.value, group, param.disabled, param.active)}
											className={`li-label ${handleTagClass(param)}`}
											aria-selected={param.active ? 'true' : 'false'}
										>
											<label className="listbox__text">{param.name}</label>
											{group !== 'month' &&  <input type="checkbox" checked={param.active} />}
										</li>
									);
								})}
							</ul>
						</div>
					);
				})}

				{/* NDR checkbox */}
				<div tabIndex="0" role="checkbox" aria-checked={`${memoizedIsNDR ? 'true' : 'false'}`} onKeyDown={handleKeyDown} className= {`input no-dutch-checkbox checkbox__checkmark ${memoizedIsNDR ? 'has-selected' : ''}`} onClick={() => handleNDRClick()}>
					<span className="checkbox__checkmark" onClick={() => handleNDRClick()}>
						{customData.i18n.agenda_ndr_name}
					</span>
					{/* <input className="checkbox" type="checkbox" checked={memoizedIsNDR} onChange={(e) => handleNDRClick(e)}></input> */}
					<div className="checkbox-arrow"  onChange={(e) => handleNDRClick(e)} style={{ borderColor: isNDR ? "transparent " : "black" }}>
						<CheckboxArrow color={isNDR ? "black" : "white"}/>
					</div>
				</div>

				{/* reset button */}
				<button onClick={() => resetParams()} className="filter__reset">
					{customData.i18n.agenda_delete_filters}
				</button>
			</div>

			{/* ------------------------------------------------------- */}

			{/* a seperate filterbar for mobile */}
			<div className="filter filter-mobile show-until-tablet-l ">

				{/* production dropdown - not part of modal */}
				<div className={`dropdown input input--prominent custom-select ${isActiveGroup('production') ? 'has-selected' : ''}`}>
					{/* selection button for dropdown */}
					<button
						className={` custom-select__trigger`}
						aria-haspopup="listbox"
						aria-labelledby="bioscoop_label"
						aria-expanded="false"
						onClick={(e) => toggleSelectList(e)}
					>
						<div className="chosen-label">
							{/* Dynamic title inside button for dropdown */}
							<p className="filter-label">{getGroupLabel('production')}</p>
							<DropdownIcon />
						</div>
					</button>

					<ul className="listbox listbox--multi listbox--multi-cinema" role="listbox" aria-labelledby="bioscoop_label" aria-multiselectable="true" aria-activedescendant="">
						{/* get all options for this group */}
						{getParamLabels('production').map((param, paramIndex) => {
							return (
								<li
									key={paramIndex}
									role="option"
									onClick={() => handleParamClick(param.value, 'production', param.disabled, param.active)}
									className={`li-label ${handleTagClass(param)}`}
									aria-selected={param.active ? 'true' : 'false'}
								>
									<label className="listbox__text">{param.name}</label>
									<input type="checkbox" checked={param.active} />
								</li>
							);
						})}
					</ul>
				</div>

				<button onClick={toggleModal} className="input dropdown">
					<span className="">{customData.i18n.agenda_filter_button_mobile}</span>
					<span className="input__counter">{displayAmountActiveFilters()}</span>
				</button>

				{/* overlay with filter options: maand, production, location */}
				{showModal && (
					<div className="dropdown--mobile">
						{/* title and close button */}
						<div className="header">
							<button className="header__button" type="button" aria-label="Close" onClick={toggleModal}>
								<CloseIcon />
								<span className="btn--full-width__text header__text ">Sluiten</span>
							</button>
						</div>
						<div>
							{['month', 'category', 'location'].map((group, index) => {
								return (
									<div className="dropdown--mobile__filters">
										<div className="">
											<p className="filter-title h5">{getGroupLabel(group)}</p>
										</div>
										{/* </button> */}

										<ul className="" role="listbox" aria-labelledby="bioscoop_label" aria-multiselectable="true" aria-activedescendant="">
											{/* get all options for this group */}
											{getParamLabels(group).map((param, paramIndex) => {
												return (
													<li
														key={paramIndex}
														role="option"
														onClick={() => handleParamClick(param.value, group, param.disabled, param.active)}
														className={`li-label ${handleTagClass(param)}`}
														aria-selected={param.active ? 'true' : 'false'}
													>
														<label className="listbox__text">{param.name}</label>
														{group !== 'month' && <input type="checkbox" checked={param.active} />}
													</li>
												);
											})}
										</ul>
									</div>
								);
							})}
							<div className="li-label dropdown--mobile__no-dutch-checkbox" onClick={(e) => handleNDRClick(e)}>
								<span>{customData.i18n.agenda_ndr_name}</span>
								<input type="checkbox" checked={memoizedIsNDR}></input>
							</div>
							<div className="filter-mobile__buttons">
								<button onClick={() => resetParams()} className="dropdown--mobile__reset">
									<span>{customData.i18n.agenda_delete_filters}</span>
								</button>
								<div className="agenda-filters__button-container">
									<button type="button" aria-label="show results" onClick={toggleModal} className="btn btn--link" href="#">
										<span className="btn--full-width__text">
											{memoizedFilteredCount} {memoizedFilteredCount.length === 1 ? customData.i18n.agenda_results_single : customData.i18n.agenda_results}
										</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default memo(Filterbar);
